
export default function Footer() {
  return (
    <footer className="bg-slate-900/50 backdrop-blur-md border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              Fortal Society
            </div>
            <p className="text-slate-400 mb-6 max-w-md">
              Trading consapevole con trasparenza totale sui risultati. 
              Analisi, esecuzione e risk management per trader seri.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-telegram-line text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-twitter-x-line text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-youtube-line text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigazione</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-slate-400 hover:text-cyan-400 transition-colors">Home</a></li>
              <li><a href="/risultati" className="text-slate-400 hover:text-cyan-400 transition-colors">Risultati</a></li>
              <li><a href="/corsi" className="text-slate-400 hover:text-cyan-400 transition-colors">Corsi</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legale</h3>
            <ul className="space-y-2">
              <li><a href="/privacy" className="text-slate-400 hover:text-cyan-400 transition-colors">Privacy Policy</a></li>
              <li><a href="/cookie" className="text-slate-400 hover:text-cyan-400 transition-colors">Cookie Policy</a></li>
              <li><a href="/disclaimer" className="text-slate-400 hover:text-cyan-400 transition-colors">Disclaimer</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-slate-400 text-sm mb-4 md:mb-0">
              <p className="mb-2">
                <strong>Disclaimer Trading:</strong> Il trading comporta rischi significativi. 
                Le performance passate non garantiscono risultati futuri. 
                Investi solo capitale che puoi permetterti di perdere.
              </p>
              <p>
                © 2024 Fortal Society. Tutti i diritti riservati.
              </p>
            </div>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-slate-500 hover:text-cyan-400 text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
